import { render, staticRenderFns } from "./staging.vue?vue&type=template&id=39230bdf&scoped=true&"
import script from "./staging.vue?vue&type=script&lang=js&"
export * from "./staging.vue?vue&type=script&lang=js&"
import style0 from "./staging.vue?vue&type=style&index=0&id=39230bdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39230bdf",
  null
  
)

export default component.exports